import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import styles from "./checkboxGroup.module.scss";
import { Box, FormGroup } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

import { ReactComponent as CheckBoxTickIcon } from "../../assets/icons/TypeChecked.svg";
import { ReactComponent as CheckBoxUncheckIcon } from "../../assets/icons/TypeDefault.svg";
import i18next from "i18next";
import PropTypes from "prop-types";

const CheckboxGroup = (props) => {
  const { handleChange, checkBoxList = [], checkBoxState = {} } = props;

  return (
    <Box className={styles.checkboxGroupWrapper} data-testid="status">
      <FormControl
        required
        component="fieldset"
        sx={{ m: 3 }}
        variant="standard"
      >
        <FormGroup>
          {checkBoxList.map((item, index) => (
            <FormControlLabel
              key={item}
              control={
                <Checkbox
                  icon={
                    <CheckBoxUncheckIcon className={styles.unChekcedIcon} />
                  }
                  checkedIcon={
                    <CheckBoxTickIcon className={styles.checkedIcon} />
                  }
                  checked={checkBoxState[item] === true}
                  onChange={handleChange}
                  name={item}
                  value={item}
                />
              }
              label={i18next.t(item)}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
};
export default CheckboxGroup;
CheckboxGroup.propTypes = {
  handleChange: PropTypes.any,
  checkBoxList: PropTypes.any,
  checkBoxState: PropTypes.any,
};
